import script from "./KPIView.vue?vue&type=script&setup=true&lang=ts"
export * from "./KPIView.vue?vue&type=script&setup=true&lang=ts"

import "./KPIView.vue?vue&type=style&index=0&id=5f78f802&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5f78f802"]])

export default __exports__